import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";

const firebaseConfig = {
apiKey: "AIzaSyDXyiubniswUYqli2rUhTfL1qWiiKDe6dI",
authDomain: "loonlog-production.firebaseapp.com",
projectId: "loonlog-production",
storageBucket: "loonlog-production.firebasestorage.app",
messagingSenderId: "775922125455",
appId: "1:775922125455:web:c4cf8eaabb588f289bbefa",
measurementId: "G-5S01PB648H"
};

const app = initializeApp(firebaseConfig);

let analytics;
if (typeof window !== "undefined") {
analytics = getAnalytics(app);
}

export { app, analytics };
